/**
 * Utility functions for calculating question statistics
 */

/**
 * Calculate the total number of questions in a question tree
 * @param {Object} question - The question object to analyze
 * @returns {number} Total number of questions including nested questions
 */
export const calculateQuestionStats = (question) => {
    let totalQuestions = 1;
    if (question?.questions) {
        totalQuestions += question.questions.length;
        question.questions.forEach((child) => {
            if (child?.questions) {
                totalQuestions += child.questions.length;
            }
        });
    }
    return totalQuestions;
};

/**
 * Calculate statistics for a section containing multiple questions
 * @param {Object} section - The section object containing questions array
 * @returns {Object} Object with questionCount and totalQuestions
 */
export const calculateSectionStats = (section) => {
    const questionCount = section?.questions?.length || 0;
    let totalQuestions = questionCount;

    section?.questions?.forEach((question) => {
        if (question?.questions) {
            totalQuestions += question.questions.length;
            question.questions.forEach((childQuestion) => {
                if (childQuestion?.questions) {
                    totalQuestions += childQuestion.questions.length;
                }
            });
        }
    });

    return { questionCount, totalQuestions };
};

/**
 * Calculate child and grandchild question counts for a specific question
 * @param {Object} question - The question object to analyze
 * @returns {Object} Object with childQuestionCount, grandchildQuestionCount, and totalQuestions
 */
export const calculateNestedQuestionStats = (question) => {
    const childQuestionCount = question?.questions?.length || 0;
    const grandchildQuestionCount =
        question?.questions?.reduce((sum, child) => sum + (child?.questions?.length || 0), 0) || 0;
    const totalQuestions = childQuestionCount + grandchildQuestionCount;

    return { childQuestionCount, grandchildQuestionCount, totalQuestions };
};
